module.exports = __webpack_public_path__ + "img/jumpfeed-full-dark.cd175bd9.svg";